import { HistoryTypes } from "../interfaces/HistoryTypes";
import { USER_DATA } from "./constants";

export function mountHistory(project_id: string, action_type: string, action_name: string) {
    return {
        project_id: project_id,
        user_uuid: JSON.parse(localStorage.getItem(USER_DATA) || '{}').uid,
        user_name: JSON.parse(localStorage.getItem(USER_DATA) || '{}').name,
        action_type: action_type,
        action_name: action_name,
        id: new Date().getTime().toString(),
        date: new Date().toUTCString()
    } as HistoryTypes
}
